<template>
    <div :class="alto_contenido()">
         <!-- HEADER TITULO -->
        <div class="titulo-contenido">
            <h1>
                <span class="negrita">PLANEACIÓN</span>
            </h1>
        </div>
        <!-- CONTENIDO PRINCIPAL -->
        <div class="container contenido_principal"> <!--el contenedor padre solo sirve para los estilos en ipad´s pro-->
            <!-- ===Apartado de las cards=== -->
      <div class="seccion_cardsOpciones my-4">
        <div class="row px-5 d-flex align-items-center justify-content-between">
          <div class="col-xs-12 col-sm-6 col-md-6">
              <!--<router-link target="_blank" :to="{name:'PED'}">-->
                <a target="_blank" :href="urlServe+'planeacion/Informacion/PED/PED-2025.pdf'">
                  <div class="card mb-3 p-1" >
                    <div class="row no-gutters">
                      <!---Imagen de la card-->
                    <div class="col-md-4 p-2 text-center justify-content-center" >
                        <!-- <img src="imagenes/img1.jpg" alt=""> -->
                        <i class='bx bx-pencil icono_card'></i>
                      </div>
                      <!---Texto de la card-->
                      <div class=" col-md-8">
                        <div class="card-body">
                          <h5 class="titulo_subsec card-title mb-4">Plan Estatal de Desarrollo Chiapas 2025-2030</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
               <!-- </router-link>-->
          </div>  
          <div class="col-xs-12 col-sm-12 col-md-6">
                <a target="_blank" :href="urlServe+'planeacion/Informacion/PED/Decreto-PED-2025.pdf'">
                    <div class="card mb-3 p-1">
                        <div class="row no-gutters d-flex">
                          <div class="col-md-4 p-2 text-center justify-content-center">
                           <!-- <img src="imagenes/img3.jpg" alt=""> -->
                         <i class='fas fa-file-alt icono_card'></i>
                          </div>
                          <div class="col-md-8">
                            <div class="card-body  justify-content-center">
                              <h5 class="titulo_subsec card-title mb-4 text-justify">Decreto No. 244, por el que se aprueba el Plan Estatal de Desarrollo 2025-2030 (PO. No. 039 de fecha 7 de mayo de 2025)</h5>
                            </div>
                          </div>
                        </div>
                    </div>
                </a>
              </div>
             
              
        
        </div>
        <div class="row px-5 d-flex align-items-center justify-content-between">
          <div class="col-xs-12 col-sm-6 col-md-6">
              <a target="_blank" href="http://www.siese.chiapas.gob.mx/">
                  <div class="card mb-3 p-1" id="seleccionado">
                      <div class="row no-gutters">
                        <div class="col-md-4 p-2 text-center justify-content-center">
                          <!-- <img src="imagenes/img2.jpg" alt=""> -->
                          <i class='bx bx-list-check icono_card'></i>
                        </div>
                        <div class="col-md-8">
                          <div class="card-body">
                            <h5 class="titulo_subsec card-title mb-4">Sistema Estatal de Seguimiento y Evaluación</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                </a>
          </div> 
          <div class="col-xs-12 col-sm-12 col-md-6">
                  <a target="_blank" href="http://www.ceieg.chiapas.gob.mx/home/">
                      <div class="card mb-3 p-1">
                          <div class="row no-gutters d-flex">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                             <!-- <img src="imagenes/img3.jpg" alt=""> -->
                             <i class='bx bx-globe icono_card'></i>
                            </div>
                            <div class="col-md-8">
                              <div class="card-body  justify-content-center">
                                <h5 class="titulo_subsec card-title mb-4">Comité Estatal de Información Estadística y Geografía</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                    </a>
              </div>
                   
        </div>
      <div class="row px-5 d-flex align-items-center justify-content-between">
           <div class="col-xs-12 col-sm-12 col-md-6">
                <a target="_blank" href="http://www.agenda2030.chiapas.gob.mx/">
                    <div class="card mb-3 p-1">
                        <div class="row no-gutters d-flex">
                          <div class="col-md-4 p-2 text-center justify-content-center">
                           <!-- <img src="imagenes/img3.jpg" alt=""> -->
                          <i class='bx bx-donate-blood icono_card'></i>
                          </div>
                          <div class="col-md-8">
                            <div class="card-body  justify-content-center">
                              <h5 class="titulo_subsec card-title mb-4">Objetivos de Desarrollo Sostenible</h5>
                            </div>
                          </div>
                        </div>
                    </div>
                </a>
              </div>
              <!--<div class="col-xs-12 col-sm-12 col-md-6">
                  <a target="_blank" href="http://www.ceieg.chiapas.gob.mx/home/">
                      <div class="card mb-3 p-1">
                          <div class="row no-gutters d-flex">
                            <div class="col-md-4 p-2 text-center justify-content-center">-->
                             <!-- <img src="imagenes/img3.jpg" alt=""> -->
                            <!-- <i class='bx bx-globe icono_card'></i>
                            </div>
                            <div class="col-md-8">
                              <div class="card-body  justify-content-center">
                                <h5 class="titulo_subsec card-title mb-4">Comité Estatal de Información Estadística y Geografía</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                    </a>
              </div>-->
      </div>

        <!--  -->
        <h5 class="text-center">Programas Sectoriales</h5>
          <div class="row px-5 d-flex align-items-center justify-content-between">
            <div class="col-xs-12 col-sm-12 col-md-6">
                <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Medio.Ambiente.Sost.y.Biodiversidad.2019-2024.pdf">
                    <div class="card mb-3 p-1">
                        <div class="row no-gutters d-flex">
                          <div class="col-md-4 p-2 text-center justify-content-center">
                           <!-- <img src="imagenes/img3.jpg" alt=""> -->
                           <i class='fas fa-check-circle icono_card'></i>
                          </div>
                          <div class="col-md-8">
                            <div class="card-body  justify-content-center">
                              <h5 class="titulo_subsec card-title mb-4">Medio Ambiente Sostenible y Biodiversidad</h5>
                            </div>
                          </div>
                        </div>
                    </div>
                </a>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6">
                  <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Honestidad.y.Funcion.Publica.2019-2024.pdf">
                      <div class="card mb-3 p-1">
                          <div class="row no-gutters d-flex">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                             <!-- <img src="imagenes/img3.jpg" alt=""> -->
                             <i class='fas fa-praying-hands icono_card'></i>
                            </div>
                            <div class="col-md-8">
                              <div class="card-body  justify-content-center">
                                <h5 class="titulo_subsec card-title mb-4">Honestidad y Función Pública</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                    </a>
              </div>
        </div>

        <div class="row px-5 d-flex align-items-center justify-content-between">
            <div class="col-xs-12 col-sm-12 col-md-6">
                <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Desarrollo.Economico.2019-2024.pdf">
                    <div class="card mb-3 p-1">
                        <div class="row no-gutters d-flex">
                          <div class="col-md-4 p-2 text-center justify-content-center">
                           <!-- <img src="imagenes/img3.jpg" alt=""> -->
                           <i class='fas fa-hand-holding-usd icono_card'></i>
                          </div>
                          <div class="col-md-8">
                            <div class="card-body  justify-content-center">
                              <h5 class="titulo_subsec card-title mb-4">Desarrollo Económico</h5>
                            </div>
                          </div>
                        </div>
                    </div>
                </a>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6">
                  <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Desarrollo.Agrop.Pesca.y.Acuac.2019-2024.pdf">
                      <div class="card mb-3 p-1">
                          <div class="row no-gutters d-flex">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                             <!-- <img src="imagenes/img3.jpg" alt=""> -->
                             <i class='fas fa-file-alt icono_card'></i>
                            </div>
                            <div class="col-md-8">
                              <div class="card-body  justify-content-center">
                                <h5 class="titulo_subsec card-title mb-4">Desarrollo Agropecuario Pesca y Acuacultura</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                    </a>
              </div>
        </div>

        <div class="row px-5 d-flex align-items-center justify-content-between">
            <div class="col-xs-12 col-sm-12 col-md-6">
                <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Salud.2019-2024.pdf">
                    <div class="card mb-3 p-1">
                        <div class="row no-gutters d-flex">
                          <div class="col-md-4 p-2 text-center justify-content-center">
                           <!-- <img src="imagenes/img3.jpg" alt=""> -->
                           <i class='bx bx-donate-blood icono_card'></i>
                          </div>
                          <div class="col-md-8">
                            <div class="card-body  justify-content-center">
                              <h5 class="titulo_subsec card-title mb-4">Salud</h5>
                            </div>
                          </div>
                        </div>
                    </div>
                </a>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6">
                  <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Sociedad.Segura.y.Estado.de.Derecho.2019-2024.pdf">
                      <div class="card mb-3 p-1">
                          <div class="row no-gutters d-flex">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                             <!-- <img src="imagenes/img3.jpg" alt=""> -->
                             <i class='bx bx-globe icono_card'></i>
                            </div>
                            <div class="col-md-8">
                              <div class="card-body  justify-content-center">
                                <h5 class="titulo_subsec card-title mb-4">Sociedad Segura y Estado de Derecho</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                    </a>
              </div>
        </div>

        <div class="row px-5 d-flex align-items-center justify-content-between">
            <div class="col-xs-12 col-sm-12 col-md-6">
                <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Bienestar.Social.2019-2024.pdf">
                    <div class="card mb-3 p-1">
                        <div class="row no-gutters d-flex">
                          <div class="col-md-4 p-2 text-center justify-content-center">
                           <!-- <img src="imagenes/img3.jpg" alt=""> -->
                           <i class='fas fa-file-alt icono_card'></i>
                          </div>
                          <div class="col-md-8">
                            <div class="card-body  justify-content-center">
                              <h5 class="titulo_subsec card-title mb-4">Bienestar Social</h5>
                            </div>
                          </div>
                        </div>
                    </div>
                </a>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6">
                  <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Educacion.2019-2024.pdf">
                      <div class="card mb-3 p-1">
                          <div class="row no-gutters d-flex">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                             <!-- <img src="imagenes/img3.jpg" alt=""> -->
                             <i class='fas fa-hotel icono_card'></i>
                            </div>
                            <div class="col-md-8">
                              <div class="card-body  justify-content-center">
                                <h5 class="titulo_subsec card-title mb-4">Educación</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                    </a>
              </div>
        </div>

                <div class="row px-5 d-flex align-items-center justify-content-between">
            <div class="col-xs-12 col-sm-12 col-md-6">
                <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectorial.Obras.Publicas.2019-2024.pdf">
                    <div class="card mb-3 p-1">
                        <div class="row no-gutters d-flex">
                          <div class="col-md-4 p-2 text-center justify-content-center">
                           <!-- <img src="imagenes/img3.jpg" alt=""> -->
                           <i class='far fa-handshake icono_card'></i>
                          </div>
                          <div class="col-md-8">
                            <div class="card-body  justify-content-center">
                              <h5 class="titulo_subsec card-title mb-4">Obras Públicas</h5>
                            </div>
                          </div>
                        </div>
                    </div>
                </a>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6">
                  <a target="_blank" href="http://www.siese.chiapas.gob.mx/wp-content/themes/siese/pdf/Planeacion/Programas-Sectoriales/Programa.Sectotial.Pol%C3%ADtica.y.Gobierno.2019-2024.pdf">
                      <div class="card mb-3 p-1">
                          <div class="row no-gutters d-flex">
                            <div class="col-md-4 p-2 text-center justify-content-center">
                             <!-- <img src="imagenes/img3.jpg" alt=""> -->
                             <i class='far fa-file-alt icono_card'></i>
                            </div>
                            <div class="col-md-8">
                              <div class="card-body  justify-content-center">
                                <h5 class="titulo_subsec card-title mb-4">Política y Gobierno</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                    </a>
              </div>
        </div>

      </div> 

        </div>
    </div>
</template>
<script>
export default {
    mounted(){
      window.scrollTo(0, 0);
    },
    methods:{
        alto_contenido(){
            if(screen.width > 1366)  return 'pantalla_grande' 
        }
    }
}
</script>
<style scoped>
.pantalla_grande{  margin-bottom: 14rem !important; }
a:hover{
  color: #fff;
  text-decoration: none;
}
/* MEDIA QUERY SOLO PARA IPAD 10 pro (MODO HORIZONTAL) */
@media only screen and 
(device-width : 1366px) and 
(device-height : 1024px) and 
(orientation : landscape) {
    .contenido_principal{
        padding-top: 5rem; 
        padding-bottom: 5rem;
    }

} 
</style>